<template>
    <div class="rpm-check-modal">
        <!-- button -->
        <b-btn size="sm" class="btn-ghost-blue"
               @click="showModal()">
            <shs-icon name="pencil"></shs-icon>
        </b-btn>

        <!-- modal -->
        <b-modal size="xl"
                 no-close-on-backdrop
                 modal-class="rpm-check-modal__modal"
                 :id="modal_id">

            <template v-slot:modal-header>
                <h5 class="m-2">{{ $i18n.gt('LABEL_RPM_CHECK') }}</h5>
                <patient-id :participant="participant">
                </patient-id>
            </template>
            <template v-slot:modal-footer>
                <b-btn variant="secondary" class="btn-cancel mr-2"
                       @click="hideModal()">
                    {{ $i18n.gt('LABEL_CANCEL') }}
                </b-btn>
                <b-btn variant="primary"
                       @click="submit()">
                    {{ $i18n.gt('LABEL_SUBMIT') }}
                </b-btn>
            </template>

            <h4 class="ml-3 mt-1">{{ $i18n.gt('HEADING_LOGS') }}</h4>

            <b-row>
                <b-col cols="1"></b-col>
                <b-col cols="5">
                    <participant-metrics-chart-time-series
                        :metrics="participant.metrics"
                        metric="ACTIVITY"
                        :highlight-start="participant.last_rpm_check_date">
                    </participant-metrics-chart-time-series>
                    <label class="ml-3">{{ $i18n.gt('LABEL_COACHING_STEPS') }}</label>
                </b-col>
                <b-col cols="5">
                    <participant-metrics-chart-time-series
                        :metrics="participant.metrics"
                        metric="WEIGHT"
                        :highlight-start="participant.last_rpm_check_date">
                    </participant-metrics-chart-time-series>
                    <label class="ml-3">{{ $i18n.gt('LABEL_COACHING_WEIGHT') }}</label>
                </b-col>
                <b-col cols="1"></b-col>
            </b-row>

            <b-row class="p-3 mt-3 rpm-check-modal__form">
                <b-col class="col-4">
                    <b-row>
                        <h4>{{ $i18n.gt('LABEL_FEEDBACK') }}</h4>
                    </b-row>
                    <b-row class="pt-2">
                        <b-form-group v-slot="{ ariaDescribedby }">
                            <b-form-radio v-model="status" :aria-describedby="ariaDescribedby"
                                          value="NOMINAL">Nominal
                            </b-form-radio>
                            <b-form-radio v-model="status" :aria-describedby="ariaDescribedby"
                                          value="OUT_OF_RANGE">Out of Range
                            </b-form-radio>
                            <b-form-radio v-model="status" :aria-describedby="ariaDescribedby"
                                          value="NEEDS_ATTENTION">Needs Immediate Attention
                            </b-form-radio>
                            <b-form-radio v-model="status" :aria-describedby="ariaDescribedby"
                                          value="NO_DATA">No Data
                            </b-form-radio>
                        </b-form-group>
                    </b-row>
                </b-col>
                <b-col class="col-8">
                    <b-form-textarea
                        id="textarea"
                        placeholder="Comments for outreach note"
                        rows="8"
                        v-model="comment"
                    ></b-form-textarea>
                </b-col>
            </b-row>
        </b-modal>
    </div>
</template>

<script>
import Vue from 'vue'
import * as _ from 'lodash'

export default Vue.extend({
    name: "RpmCheckModal",
    props: {
        provider: Object,
        onSubmit: Function,
    },
    computed: {
        participant() {
            return this.provider.participant
        },
        modal_id() {
            return `rpm_check_${this.provider.participant_id}`
        },
        availableMetrics() {
            let metricsWithReadings = _.filter(this.provider.participant.metrics, met => met.readings.length > 0 &&
                met.metric != 'SYSTOLIC' &&
                met.metric != 'DIASTOLIC')
            return _.uniq(_.map(metricsWithReadings, (met) => met.metric))
        },
    },
    data() {
        return {
            status: null,
            comment: "",
        }
    },
    methods: {
        hideModal() {
            this.$bvModal.hide(this.modal_id)
        },
        showModal() {
            this.$bvModal.show(this.modal_id)
        },
        submit() {
            let check = {
                participant_id: this.provider.participant_id,
                practice_id: this.provider.practice_id,
                status: this.status,
                comment: this.comment
            }
            this.$api.createItem(this, 'rpm-check', check)

            this.onSubmit()
        }
    },

})
</script>

<style scoped>

.rpm-check-modal__form {
    background-color: #eeeeee;
}

</style>
